
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import { TableData } from '@/model/LocationTopicResponsibleData';
import FormInput from '@/components/form/FormInput.vue';
import FormSelector from '@/components/form/FormSelector.vue';
import ConfirmationModal from '@/components/modal/ConfirmationModal.vue';
import Draggable from 'vuedraggable';
import { Validations } from 'vuelidate-property-decorators';
import { maxLength, required } from 'vuelidate/lib/validators';
import { FormItemWithClass } from '@/model/form/FormItem';
import ColorPicker from '@/components/form/ColorPicker.vue';
import LocationTopicResponsibleForm from '@/components/master-data/LocationTopicResponsibleForm.vue';

@Component({
    components: {
        ConfirmationModal,
        Draggable,
        FormInput,
        FormSelector,
        LocationTopicResponsibleForm,
        ColorPicker,
    },
})
export default class LocationTopicResoposibleTable extends Vue {
    @Prop({ type: Array }) readonly tableDatas!: TableData[];

    @Prop({ type: Boolean, default: false }) readonly colorPicker!: boolean;

    @Prop({ type: String, default: null }) readonly type!: string;

    sortedTableDatas = [...this.tableDatas];

    editData: TableData = {
        id: null,
        name: '',
        order: 0,
        color: '',
    };

    @Validations()
    validations = {
        editData: {
            name: {
                required,
                maxLength: maxLength(35),
                alreadyAddedAndNotMe: (
                    _value: string,
                    vm: TableData,
                ): boolean => {
                    return !(
                        this.tableDatas
                            .map((tableData) => tableData.name?.toLowerCase())
                            .includes(vm.name?.toLowerCase()) &&
                        vm.name?.toLowerCase() !==
                            this.tableDatas
                                .find((tableData) => tableData.id === vm.id)
                                ?.name?.toLowerCase()
                    );
                },
            },
        },
    };

    showAddForm = false;

    dragOptions = {
        animation: 200,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost',
    };

    get getOptions(): FormItemWithClass<number>[] {
        return Array.from(
            Array(this.tableDatas.length),
            (_, index) => index + 1,
        ).map((order) => {
            return {
                id: order,
                value: order,
                name: order.toString(),
            };
        });
    }

    get getDisabledState(): (tableData: TableData) => boolean | null {
        return (tableData: TableData): boolean | null => {
            return (
                tableData.name === this.editData.name &&
                tableData.color === this.editData.color
            );
        };
    }

    @Watch('tableDatas')
    onLocationsChanged(): void {
        this.sortedTableDatas = this.tableDatas;

        if (this.editData?.id) {
            const newEditedLocation = this.tableDatas.find(
                (tableData) => tableData.id === this.editData.id,
            );

            if (newEditedLocation) {
                this.editData.order = newEditedLocation.order;
            }
        }
    }

    @Emit('onAdd')
    onAdd(tableData: TableData | null): TableData | null {
        this.showAddForm = false;
        return tableData;
    }

    @Emit('onRemove')
    onRemove(tableData: TableData): TableData {
        this.$bvModal.hide(`${this.type}-delete-modal${tableData.id}`);
        return tableData;
    }

    onEdit(tableData: TableData): void {
        this.editData = { ...tableData };
    }

    onConfirmEdit(tableData: TableData): void {
        const tempEditData = { ...this.editData };
        this.editData.id = null;
        this.$bvModal.hide(`${this.type}-edit-modal${tableData.id}`);
        this.onSaveEdit(tempEditData);
    }

    @Emit('onSaveEdit')
    onSaveEdit(tableData: TableData): TableData {
        return tableData;
    }

    onResetEdit(): void {
        this.editData.id = null;
    }

    onMoved({
        moved: { newIndex, element },
    }: {
        moved: { newIndex: number; element: TableData };
    }): void {
        const editedLocation = { ...element };

        editedLocation.order = newIndex + 1;

        this.onSaveEdit(editedLocation);
    }
}
